var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('default-layout',{staticClass:"register-table"},[_c('div',{staticClass:"manual-register"},[_c('RecipientList',{attrs:{"use-selection":true,"has-next-button":true,"unit":_vm.recipientListUnit,"include-column":_vm.recipientIncludeFilter,"is-header-font-size-large":true},on:{"apply":_vm.handleSelectedRecipients}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }